import { Modal, Input, Upload, Button, Form, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { bg_button, bg_shadow } from "constant/css";
import { useLoading } from "context/loadingContext";
import CreateFunctionCall from "functions/ai/createFunctionCall";
import handleUpload from "functions/utils/uploadImage";

const AddFunctionModal = ({ functionCallId, open, onClose, refresh }) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  useEffect(() => {
    if (functionCallId) {
      fillData(functionCallId);
    } else form.resetFields();
  }, [functionCallId]);
  const handleSubmit = async () => {
    try {
      showLoading();
      const values = await form.validateFields();
      console.log("Form values:", values);
      const response = await CreateFunctionCall(values);
      console.log("Submitted function:", response.data);
      if (response && response.data) {
        console.log(values.image);
        const result = await handleUpload(
          `/ai/functionCalls/${response.data.id}/photo`,
          values.image.fileList,
          (e) => console.log("Image upload status:", e)
        );
        message.success("Function saved.");
        setTimeout(() => {
          form.resetFields();
          refresh();
          onClose();
        }, 1000);
      } else {
        message.error("Failed to save function.");
      }
    } catch (err) {
      message.error("Please complete the form.");
    } finally {
      hideLoading();
    }
  };
  const fillData = (id) => {
    // Fetch function data by ID and set form values
    // This is a placeholder, replace with actual fetch logic
    const mockData = {
      name: "Sample Function",
      description: "This is a sample function description.",
      answer: "Sample answer for the function.",
      image: null, // Replace with actual image URL if available
    };
    form.setFieldsValue(mockData);
  };
  return (
    <Modal
      open={open}
      title={functionCallId ? "Засах" : "Шинэ функц"}
      onCancel={onClose}
      onOk={handleSubmit}
      footer={null}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          name="name"
          label="Функцийн нэр"
          rules={[{ required: true }]}
        >
          <Input placeholder="ХЭРХЭН_НЭХЭМЖЛЭЛ_ҮҮСГЭХ_ВЭ" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Тайлбар"
          rules={[{ required: true }]}
        >
          <Input.TextArea
            rows={2}
            placeholder="Нэхэмжлэл үүсгэх талаар мэдээлэл өгнө"
          />
        </Form.Item>
        <Form.Item name="answer" label="Хариулт" rules={[{ required: true }]}>
          <Input.TextArea
            placeholder="Нэхэмжлэл үүсгэхдээ та дараах алхмуудыг дагана үүнд ...."
            rows={2}
          />
        </Form.Item>
        <Form.Item
          name="image"
          label={
            <span>
              Тайлбар зураг{" "}
              <span className="text-xs text-gray-400">
                (байхгүй байж болно)
              </span>
            </span>
          }
        >
          <Upload beforeUpload={() => false}>
            <Button
              className={`${bg_button} text-white border-none ${bg_shadow}`}
              icon={<UploadOutlined />}
            >
              Дарж зураг оруулна уу
            </Button>
          </Upload>
        </Form.Item>
        <div className="flex flex-row mt-10 justify-center gap-2">
          <Button
            className={`text-red-400 border-1 border-red-200 hover:bg-red-100`}
            onClick={onClose}
          >
            Хаах
          </Button>
          <Form.Item>
            <Button
              type="primary"
              className={`${bg_button} text-white border-none ${bg_shadow}`}
              onClick={handleSubmit}
            >
              {functionCallId ? "Засах" : "Нэмэх"}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default AddFunctionModal;
